<template>
  <div id="app">
    <!-- <Topbar ref="topbar" /> -->
    <router-view />
    <!-- <Footer /> -->
    <link src="./styles/custom.css" />
  </div>
</template>
<script>
// vuex
import { mapActions } from "vuex";

var fontFile = null;
import Topbar from "./components/commonality/publicTopbar.vue";
import Footer from "./components/commonality/publicFooter.vue";
// import './styles/custom.css';
export default {
  name: "App",
  components: {
    Topbar,
    Footer,
  },
  provide() {
    // 提供reload方法
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      GrayFilter: {},
      colorStyle: [],
      printInfo: {},
    };
  },
  created() {
    console.log("App created");
    // this.addCss();
    // this.getGrayFilter();
    // import("./styles/custom.css")
    let site = "";
    // 获取网站配色
    // this.getSettingsStyleApply();

    /** 考试信息 */
    this.fetchExamInfoById();
  },
  mounted() {
    // 页面加载时进行浏览器检测
    if (this.isIE() || this.is360Browser()) {
      this.isShowTip = true;
    }
  },
  methods: {
    ...mapActions(["fetchExamDataList", "fetchExamInfoById"]),
    // 检测 IE 浏览器
    isIE() {
      return !!window.ActiveXObject || "ActiveXObject" in window;
    },
    // 检测 360 浏览器
    is360Browser() {
      if (navigator.userAgent.indexOf("Chrome") > -1) {
        let mimeTypes = navigator.mimeTypes;
        for (let plugin in mimeTypes) {
          if (
            mimeTypes[plugin] &&
            mimeTypes[plugin].type === "application/x-shockwave-flash"
          ) {
            let description = mimeTypes[plugin].description.toLowerCase();
            if (description.indexOf("shockwave") > -1) {
              return true;
            }
          }
        }
      }
      return false;
    },

    getSettingsStyleApply() {
      this.$api.home.getSettingsStyleApply("inner").then((res) => {
        localStorage.setItem("colorStyle", res.data.extend);
        const data = JSON.parse(res.data.extend);
        if (data.dataColorDtoList) {
          this.settingsColor(data.dataColorDtoList);
          const urls = window.location.href;
          if (urls.match(/#(\S*)/)[1] == "/") {
            this.$refs.topbar.headInfo.animation = data.dataHead.animation;
            this.$refs.topbar.headInfo.headImg = data.dataHead.image;
          }
        } else {
          this.settingsColor(data);
        }
      });
    },
    settingsColor(data) {
      var root = document.querySelector(":root");
      //主色调
      root.style.setProperty("--main-color", data[0].color);
      root.style.setProperty("--main-color-1", data[0].children[0].color);
      root.style.setProperty("--main-color-2", data[0].children[1].color);
      root.style.setProperty(
        "--main-color-gradation1",
        data[0].children[2].color,
      );
      root.style.setProperty(
        "--main-color-gradation2",
        data[0].children[3].color,
      );
      root.style.setProperty("--main-color-3", data[0].children[4].color);
      root.style.setProperty("--main-color-4", data[0].children[5].color);

      // 副色调
      root.style.setProperty("--minor-color", data[1].color);
      root.style.setProperty("--minor-color-1", data[1].children[0].color);
      root.style.setProperty("--minor-color-2", data[1].children[1].color);
      root.style.setProperty(
        "--minor-color-gradation1",
        data[1].children[2].color,
      );
      root.style.setProperty(
        "--minor-color-gradation2",
        data[1].children[3].color,
      );
      // 修改
      // 特定页面单独色调
      root.style.setProperty("--alone-color-1", data[3].children[0].color);
      root.style.setProperty("--alone-color-2", data[3].children[1].color);
    },
    //长者模式
    addCss() {
      // return
      let FontType = localStorage.getItem("FONTS");
      if (FontType == "true") {
        import("./styles/custom.css")
          .then(() => {
            console.log("custom.css imported");
          })
          .catch((error) => {
            console.error("Failed to import custom.css", error);
          });
      } else {
        // 获取所有的style标签
        this.$nextTick(() => {
          let styleTags = document.getElementsByTagName("style");
          for (let index = 0; index < styleTags.length; index++) {
            const element = styleTags[index].innerHTML.substr(2, 4);
            if (element == "FONT") {
              styleTags[index].remove();
            }
          }
        });
      }
    },
    // 是否开启滤镜
    getGrayFilter() {
      this.$api.home.grayFilter().then(({ data }) => {
        if (data[0]?.text === "on") {
          this.GrayFilter = { filter: "grayscale(100%)" };
        }
      });
    },
    // 重置页面
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    toggleCSS() {
      let FontType = localStorage.getItem("FONTS");
      if (FontType == "true") {
        fontFile = true;
      } else {
        fontFile = null;
      }

      if (fontFile) {
        fontFile = null;
        localStorage.setItem("FONTS", false);
        this.$nextTick(() => {
          let styleTags = document.getElementsByTagName("style");
          for (let index = 0; index < styleTags.length; index++) {
            const element = styleTags[index].innerHTML.substr(2, 4);
            if (element == "FONT") {
              // styleTags[index].remove()
              styleTags[index].parentNode.removeChild(styleTags[index]);
            }
          }
        });
        history.go(0);
      } else {
        fontFile = true;
        localStorage.setItem("FONTS", true);
        // import ('./styles/custom.css');
        import("./styles/custom.css").then((module) => {
          // 这里可以添加你的样式应用到页面的代码
        });
      }
    },
  },
};
</script>
<style>
/* @import url('./styles/custom.css'); */
img {
  -webkit-user-drag: none;
}
</style>
<!-- <style ref="css" id="custom" src="./styles/custom.css" ></style> -->
<style>
body {
  font-family: Microsoft YaHei;
}
@media print {
  body * {
    visibility: hidden;
  }

  #printArea,
  #printArea * {
    visibility: visible;
  }

  #printArea {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
